import { Component, ViewChild } from '@angular/core';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-setor-tabset',
  templateUrl: './setor-tabset.component.html',
  styleUrls: ['./setor-tabset.component.css']
})
export class SetorTabsetComponent {
  @ViewChild('tabset', { read: NgbTabset, }) tabset: NgbTabset;

  voltar(): void {
    if (this.tabset) {
      this.tabset.select('setor');
    }
  }

  constructor() {
  }
}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/setor-tabset/setor-tabset.component.ts